goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_clockwise_play_svg$default");
shadow.js.shim.module$src$svg$arrows$arrow_clockwise_play_svg$default = shadow.js.shim.module$src$svg$arrows$arrow_clockwise_play_svg.default;
